import { render, staticRenderFns } from "./HighlightedMessage.vue?vue&type=template&id=7313da22"
import script from "./HighlightedMessage.vue?vue&type=script&lang=js"
export * from "./HighlightedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports